import { UpdateOnCallRequest } from '~/domain/usecases/onCallRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  Conflict,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteUpdateOnCallRequest implements UpdateOnCallRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateOnCallRequest.Model>;

  constructor(url: string, httClient: HttpClient<UpdateOnCallRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  update = async (
    params: UpdateOnCallRequest.Params,
  ): Promise<UpdateOnCallRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.requestId}`,
      body: params.body,
      method: 'patch',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.conflict:
        throw new Conflict();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
